import React from 'react';
import { List } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { resolveRequestWorkflow } from '../state/state';

const RequestNameListItem = ({ name }) => (
  <List.Item className="aridhia-request-name-list-item">
    <List.Header>
      <FormattedMessage id="request.list.name.title" />
    </List.Header>
    <List.Description className="aridhia-form-item-description" content={name} />
  </List.Item>
);

const mapStateToProps = ({
  requests: { requests },
  workflows: { workflows },
}, ownProps) => {
  const { request } = resolveRequestWorkflow(requests, workflows, ownProps, { name: '' });
  return ({ name: request.name });
};

export default connect(mapStateToProps)(RequestNameListItem);
